import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = props => {
  const classes = useStyles();
  const { view } = props;
  return (
    <Box className={`${classes.container} ${view} skeleton`}>
      <Skeleton variant="rect" className="img skeleton" />
      <Box
        className="content skeleton"
        display="flex"
        flexDirection="column"
        flexGrow={1}
        px={2}
        py={2}
      >
        <Skeleton className="title" variant="text" width="100%" />
        <Skeleton className="instructor" variant="text" width="25%" />
      </Box>
    </Box>
  );
};

export default Loading;
